document.addEventListener("DOMContentLoaded", () => {
    const body = document.querySelector('body');
    const menuTrigger = document.querySelector('.menu-toggle');
    const nav = document.querySelector('.main-navigation');
    const btnCloseNav = document.querySelector('.btn-close-nav');
    // remove 'hide' class from nav
    nav.classList.remove('hide');

    function toggleNav() {
        nav.classList.toggle('active');
        body.classList.toggle('scroll-lock');
    };

    menuTrigger.addEventListener('click', ()=>{
        toggleNav();
    });

    btnCloseNav.addEventListener('click', ()=>{
        toggleNav();
    });

    // close nav using Escape key
    document.addEventListener('keydown', function(event) {
        if (event.key == 'Escape' && nav.classList.contains('active')) {
            toggleNav();
        }
    });

    // image preview
    const menuItems = nav.querySelectorAll('ul li');
    const imagePreview = nav.querySelector('.image-preview');

    menuItems.forEach(item => {
        item.addEventListener('mouseenter', (e) => {
            const imageUrl = item.getAttribute('data-image');
            imagePreview.style.backgroundImage = `url(${imageUrl})`;
            imagePreview.style.display = 'block';
        });

        item.addEventListener('mousemove', (e) => {
            const offsetX = (e.clientX - window.innerWidth / 2) * 0.2; // Adjust sensitivity
            const offsetY = (e.clientY - window.innerHeight / 2) * 0.2; // Adjust sensitivity
            imagePreview.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
        });

        item.addEventListener('mouseleave', () => {
            imagePreview.style.display = 'none';
        });
    });



    // sticky nav
    // function updateMenuTrigger() {
    //     if (menuTrigger) {
    //         const scrollPosition = window.pageYOffset;
    
    //         if (scrollPosition >= 120) {
    //             body.classList.add('sticky-nav');
    //         } else {
    //             body.classList.remove('sticky-nav');
    //         }
    //     }
    // }
    
    // window.addEventListener('resize', () => {
    //     updateMenuTrigger();
    // });
    
    // window.addEventListener('scroll', () => {
    //     updateMenuTrigger();
    // });
});